var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { columnsToNumeral } from '../../utilities/SemanticUtils';
export const GridColumn = (_a) => {
    var { children, className, el: TagName = 'div', desktop, floated, largescreen, mobile, only, stretched, tablet, textAlign, verticalAlign, widescreen, width } = _a, props = __rest(_a, ["children", "className", "el", "desktop", "floated", "largescreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"]);
    const desktopColspan = columnsToNumeral(desktop);
    const largescreenColspan = columnsToNumeral(largescreen);
    const mobileColspan = columnsToNumeral(mobile);
    const tabletColspan = columnsToNumeral(tablet);
    const widescreenColspan = columnsToNumeral(widescreen);
    const colspan = columnsToNumeral(width);
    const GridColumnClasses = classnames('GridColumn', className, {
        [`GridColumn--${floated}-floated`]: floated,
        [`GridColumn--${only}-only`]: only,
        'GridColumn--stretched': stretched,
        [`GridColumn--text-align-${textAlign}`]: textAlign,
        [`GridColumn--vertical-align-${verticalAlign}`]: verticalAlign,
        [`GridColumn--${desktopColspan}-wide-desktop`]: desktopColspan,
        [`GridColumn--${largescreenColspan}-wide-largescreen`]: largescreenColspan,
        [`GridColumn--${mobileColspan}-wide-mobile`]: mobileColspan,
        [`GridColumn--${tabletColspan}-wide-tablet`]: tabletColspan,
        [`GridColumn--${widescreenColspan}-wide-widescreen`]: widescreenColspan,
        [`GridColumn--${colspan}-wide`]: colspan,
    });
    return (React.createElement(TagName, Object.assign({ className: GridColumnClasses }, props), children));
};
//# sourceMappingURL=GridColumn.js.map